import currencyFormatter from 'currency-formatter';
import {
  ADD_ON_FEE_TYPE_VALUE,
  ADD_ON_USER_TYPE_VALUE,
} from '../../../containers/settings/AddonTemplate/utils/fieldAddonService';
import { CCLiteCommonFunc } from '../../../utils/commonFunctions';

export const CURRENCY_FALLBACK = 'USD';

export const formatValue = (service, currencyISO) => {

  if(_.isNumber(service?.editedValue)) {
    return checkPercentType(service) ? `${service?.editedValue}%` : currencyFormatter.format(service?.editedValue, {
      code: currencyISO || service?.feeConfig?.currency || CURRENCY_FALLBACK,
    });
  }
  
  const fee = service?.feeConfig;
  if (!fee) return '';
  if (fee.type === 'amount') {
    return currencyFormatter.format(
      getValueDisplay(service, fee.value, currencyISO),
      {
        code: currencyISO || fee.currency || CURRENCY_FALLBACK,
      }
    );
  }
  if (checkPercentType(service)) {
    return `${fee.value || 0}%`;
  }
  if (fee.type === 'custom') {
    return '';
  }
  return '';
};

export const getValueDisplay = (service, value, currencyISO) => {
  if (service.feeConfig?.convertedValue)
    return CCLiteCommonFunc.currencyNumberFormat(
      service.feeConfig?.convertedValue,
      currencyISO
    );
  if (value) return value;
};

export const checkPercentType = (service) => {
  const fee = service?.feeConfig;
  if (!fee) return false;
  return fee.type === 'percentageSubtotal' || fee.type === 'percentageTotal';
};

export const sortAddonsByNameAndHideDriverType = (addons = []) => {
  return (addons || [])
    ?.filter((addon) => addon.userType === ADD_ON_USER_TYPE_VALUE.customer)
    ?.sort((a, b) => {
      const aIsCustom = a?.feeConfig?.type === ADD_ON_FEE_TYPE_VALUE.custom;
      const bIsCustom = b?.feeConfig?.type === ADD_ON_FEE_TYPE_VALUE.custom;
      
      // Nhóm có type khác custom sẽ xếp trước nhóm có type = custom
      if (aIsCustom && !bIsCustom) {
        return 1; // a (custom) xếp sau b (không custom)
      }
      if (!aIsCustom && bIsCustom) {
        return -1; // a (không custom) xếp trước b (custom)
      }
      
      // Trong cùng nhóm, sắp xếp theo tên
      return (
        a?.name?.localeCompare(b?.name, undefined, { sensitivity: 'base' }) || 0
      );
    });
};

export const getMaxQuantity = (service) => {
  const unit = service?.feeConfig?.unit;
  if (unit === 'each') {
    return Math.max(0, Number(service?.feeConfig?.maxQuantity) || 0);
  }
  return 1;
};

export const categorizeAddons = (addonServices) => {
  const bucket = { included: [], compulsory: [], optional: [] };
  (addonServices || []).forEach((svc) => {
    if (!svc?.feeConfig) return;
    if (
      svc.feeConfig.value === 0 &&
      svc.isRequired &&
      svc.feeConfig.type !== ADD_ON_FEE_TYPE_VALUE.custom
    ) {
      bucket.included.push(svc);
    } else if (svc.isRequired) {
      bucket.compulsory.push(svc);
    } else {
      bucket.optional.push(svc);
    }
  });
  return {
    included: sortAddonsByNameAndHideDriverType(bucket.included || []),
    compulsory: sortAddonsByNameAndHideDriverType(bucket.compulsory || []),
    optional: sortAddonsByNameAndHideDriverType(bucket.optional || []),
  };
};
